import { addBusinessDays } from "date-fns";

export const BUSINESS_DAYS_BEFORE_DAMAGED_PRODUCT_DISPOSAL = 7;

export const getIsDamagedProductDisposed = (isDisposed: boolean, createdAt: Date): boolean =>
  isDisposed ||
  addBusinessDays(new Date(createdAt), BUSINESS_DAYS_BEFORE_DAMAGED_PRODUCT_DISPOSAL).getTime() < new Date().getTime();
